import { BackendOption, Option } from '~/models/shared/types'

export function formatBackendOptionToOption(o: BackendOption): Option {
  return {
    text: o.name,
    value: o.value
  }
}
